/**
 * Form Container
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'input-select-meteor';

class InputSelect extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        select: this.element.querySelector('select'),
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.select.addEventListener('change', () => {
            if (this.elements.select.value) {
                this.elements.select.classList.add('has-value');
            } else {
                this.elements.select.classList.remove('has-value');
            }
        });
    }

    /**
     * Initialize Component
     */
    init() {
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, InputSelect);
